import { fetchAll } from './fetchAll';

/**
 * ページ分割された一覧をすべて読む。
 *
 * ADM-09。選択肢や集計は「全件」を前提にしているのに、1ページ目（10件、
 * あるいは15件）だけを読んでいた。件数が増えると、選べない項目や
 * 合わない集計が静かに生まれる。
 *
 * BE-21（2026-10-11 PM 判断）。以前は50ページ（5,000件）で黙って切っていた。全件取得の
 * 共通の処理（config/fetchAll）を通し、5,000件を超える一覧は止めて画面に案内を出す。
 */
export function fetchAllPages<T>(path: string): Promise<T[]> {
  return fetchAll<T>(path);
}
